<template>
  <div v-if="dataLoaded">
    <v-card-title class="text-h5 align-center justify-center mb-8">
      {{ $t('productInfoLabel') }}
    </v-card-title>
    <div class="d-flex mb-9">
      <div class="product-info">
        <div class="text-h6 mb-4">{{ $t('productLabel') }}</div>
        <div class="body-1 mb-2">
          {{ $t('productCreatedByLabel') }}: {{ product.createdBy.fullName }}
        </div>
        <div class="body-1">
          {{ $t('productIdLabel') }}: {{ product.configurationId }}
        </div>
        <div class="d-flex mt-4">
          <template>
            <v-btn v-if="product.status === inProgress" class="red white--text mr-3" :to="'/product-configurator'">
              {{ $t('inProgressLabel') }}
            </v-btn>
            <v-btn v-else-if="product.status === readyForOrder" class="green white--text mr-3" :to="'/product-configurator'">
              {{ $t('readyForOrder') }}
            </v-btn>
            <v-btn v-if="canOrder" class="green white--text mr-3" :loading="orderLoading"
                   @click="makeOrder">{{ $t('orderNowLabel') }}
            </v-btn>
          </template>
<!--           <v-btn v-if="canGetprice" color="primary" outlined>{{ $t('getPriceLabel') }}</v-btn>-->
          <div v-if="canGetprice">
            <v-btn
              v-if="!isPriceFetched"
              color="primary"
              :loading="loadingPrice"
              @click="getPrice()"
              outlined
              >
              {{ $t('getPriceLabel') }}
            </v-btn>
            <div v-else class="d-flex align-center" style="height: 100%">
              <div class="body-2 mr-2 font-weight-bold">Price:</div>
              <div>{{ price }}€</div>
            </div>
          </div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="buttons-container d-flex flex-column align-center">
        <div class="edit-buttons">

          <v-btn class="mr-2 elevation-0" fab dark small color="primary" download="ProductConfiguration.json"
            :href="jsonBase64File" v-if="jsonBase64File">
            <v-icon>mdi-code-json</v-icon>
          </v-btn>
          <v-btn class="mr-2 elevation-0" fab dark small color="primary" @click="generateNewPdf()">
            <img src="../assets/images/pdf-file.svg" height="25px" alt="" />
          </v-btn>

          <!-- <v-dialog v-model="toggleNotes" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=""
                outlined
                medium
                fab
                color="primary mr-2"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-notebook-edit</v-icon>
              </v-btn>
            </template>
            <v-card style="position: relative">
              <v-card-title>
                <span class="headline">Notes</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="mb-8">
                      <v-textarea
                        v-model="note"
                        min-height="400px"
                        outlined
                        label="Write a note"
                        hint="You can type your notes here, then click Add Note"
                      >
                      </v-textarea>
                      <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="addNote()"
                          min-width="140px"
                          color="green"
                          class="white--text"
                          >Save</v-btn
                        >
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="notes-list">
                        <div
                          class="note mb-3"
                          v-for="(note, index) in notes"
                          :key="index"
                        >
                          <div class="body-2 mb-1">{{ note.text }}</div>
                          <div class="body-2 primary--text mb-1">
                            {{ note.datePosted }} - note by {{ note.user }}
                          </div>
                          <a
                            href="javascript:void(0)"
                            @click="removeNote(index)"
                          >
                            <div class="close">
                              <v-icon medium color="red"
                                >mdi-close-circle-outline</v-icon
                              >
                            </div>
                          </a>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <a href="javascript:void(0)">
                <div class="close" @click="toggleNotes = false">
                  <v-icon medium>mdi-close</v-icon>
                </div>
              </a>
            </v-card>
          </v-dialog> -->
          <!-- <v-btn fab dark color="red" class="white--text">
            <v-icon dark>mdi-delete</v-icon>
          </v-btn> -->
        </div>
      </div>
    </div>
    <v-flex class="mb-8">
      <div class="text-h6 mb-2">{{ $t('informationLabel') }}</div>
      <div class="text-body-1">
        {{ $t('productInformationDescription') }}
      </div>
    </v-flex>
  </div>
</template>

<script>
  import {
    mapActions
  } from "vuex";
  import StatusTypes from "../configurator/StatusTypes";
  import UserTypes from "../auth/userTypes";
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  export default {
    data() {
      return {
      isPriceFetched: false,
      loadingPrice: false,
        note: "",
        notes: [{
          text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
          user: "Wertheim Sales",
          datePosted: "9/1/2020, 5:45:31 AM",
        }],
        toggleNotes: false,
        inProgress: 0,
        readyForOrder: 0,
        ordered: 0,
        offer: 0,
        configurated: true,
        product: null,
        dataLoaded: false,
        canGetprice: false,
        canOrder: false,
        price: 0,
        jsonBase64File: '',
        orderLoading: false
      };
    },
    methods: {
      ...mapActions("configuratorModule", ["setProductId"]),

      async fetchProduct() {
        this.$EventBus.$emit("loading", true);
        await this.axios
          .get("api/productconfiguration/getProductConfiguration", {
            params: {
              id: this.$route.params.productId,
            },
          })
          .then((response) => {
            this.$EventBus.$emit("loading", false);

            this.product = response.data.product;
            this.setProductId(this.$route.params.productId);
            this.checkIfCanGetPrice();
            this.checkIfCanOrder();
            this.dataLoaded = true;
          })
          .catch((error) => {
            console.log(error);
          });
      },

      checkIfCanGetPrice() {
        var userType = parseInt(this.$store.state.user.userType);
        if (
          userType == UserTypes.WertheimAdministrator ||
          userType == UserTypes.WertheimSales ||
          userType == UserTypes.SalesPartnershipAdmin ||
          userType == UserTypes.SalesPartnershipSales
        ) {
          if (this.product.status === StatusTypes.ReadyForOrder) {
            this.canGetprice = true;
          }
        }
      },
      checkIfCanOrder(){
        const userType = parseInt(this.$store.state.user.userType);
        this.canOrder = (userType === UserTypes.WertheimAdministrator ||
            userType === UserTypes.WertheimSales ||
            userType === UserTypes.SalesPartnershipAdmin ||
            userType === UserTypes.SalesPartnershipSales) &&
            this.product.status === StatusTypes.Offer

      },
      getPrice() {
        this.loadingPrice = true;
        this.axios
          .get("/api/sap/getProductPrice", {
            params: {
              productId: this.$route.params.productId,
            },
          })
            .then((response) => {
              var price = response.data;
              this.price = price[0].totalAmount;
              this.isPriceFetched = true;
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
            })
            .finally(() => {
              this.loadingPrice = false;
            });
      },
      makeOrder() {
        this.orderLoading = true

        const data = {
          ProductId: this.$route.params.productId,
        };
        this.axios
            .post("/api/sap/makeOrder", data)
            .then((response) => {
              var data = JSON.parse(response.data);

              this.$router.push('/dashboard/orders')
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.orderLoading = false;
            });
      },
      addNote() {
        var noteObj = {};
        (noteObj.text = this.note), (noteObj.user = "WT Admin");
        noteObj.datePosted = new Date().toLocaleString();
        this.notes.push(noteObj);
        this.note = "";
      },
      removeNote(index) {
        this.notes.splice(index, 1);
      },

      generateJsonData(productId) {
        this.axios.get('/api/productconfiguration/getProductJsonData', {
          params: {
            productId: this.$route.params.productId
          }
        }).then(response => {
          var data = decodeURIComponent(escape(atob(response.data))) ;
          var fileURL = window.URL.createObjectURL(new Blob([data], {type: "application/json"}))
          this.jsonBase64File = fileURL;
        }).catch(error => {

        });
      },

      generatePdfData() {
        this.axios.get('/api/productconfiguration/getProductJsonData', {
          params: {
            productId: this.$route.params.productId
          }
        }).then(response => {
          var data = decodeURIComponent(escape(atob(response.data))) ;
          var parsedJson = JSON.parse(data);
          var doc = new jsPDF();

          var array = new Array();
          for (var i = 0; i < parsedJson.KTU.length; i++) {
            array.push(new Array(parsedJson.KTU[i].name, parsedJson.KTU[i].value));
          }

          doc.autoTable({
            head: [
              ['Name', 'Value']
            ],
            body: array,
          })

          doc.save('ProductConfiguration.pdf')

        }).catch(error => {

        });
      },
      generateNewPdf(){
        NProgress.start();
        this.axios.get('/api/productconfiguration/getProductPdfData', {
          params: {
            productId: this.$route.params.productId
          }
        }).then(response => {
          const blob = this.b64toBlob(response.data, 'application/pdf');
          const blobUrl = URL.createObjectURL(blob);
          NProgress.done();

          const x = window.open(blobUrl, '_blank');
          setTimeout(() => {
            x.document.title = 'Product Configuration'
          }, 1000)

        }).catch(error => {
          NProgress.done();
        });
      },
      b64toBlob(b64Data, contentType='', sliceSize=512){
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }
    },
    mounted() {
      this.fetchProduct();
      this.generateJsonData();
      this.readyForOrder = StatusTypes.ReadyForOrder;
      this.offer = StatusTypes.Offer;
      this.inProgress = StatusTypes.InProgress;
      this.ordered = StatusTypes.Ordered;
    },
  };
</script>

<style lang="scss" scoped>
  .h-250 {
    height: 250px;
  }

  .h-100 {
    height: 100%;
  }

  .w-100 {
    width: 100%;
  }
</style>